import { render, staticRenderFns } from "./create.vue?vue&type=template&id=37cf5412&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cf5412')) {
      api.createRecord('37cf5412', component.options)
    } else {
      api.reload('37cf5412', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=37cf5412&", function () {
      api.rerender('37cf5412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/create.vue"
export default component.exports